<template>
  <div
    :class="{
      [$style.footer]: true,
      [$style.footerFullWidth]: settings.isContentNoMaxWidth
    }"
  >
    <div :class="$style.inner">
      <div class="row">
        <div class="col-md-8">
          <p>
            <strong>Neopath Institute Management</strong>
          </p>
          <p>An institute management solution developed by Neopath Technologies Private Limited.</p>
          <p>&copy; {{moment().format('YYYY')}} Neopath Technologies Pvt Ltd</p>
        </div>
        <div class="col-md-4">
          <div :class="$style.logo">
            <img src="/resources/images/air-logo.png" alt="neoskool" width="200px"/>
<!--            <div :class="$style.logoName">Power Campus</div>
            <div :class="$style.logoDescr">Institute Management</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: mapState(['settings']),
  methods: { moment },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
